export default "__VITE_ASSET__9117a23f__"